import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import "./Slider.css";

const Separator = styled("div")(
  ({ theme }) => `
  height: ${theme.spacing(3)};
`
);

// const marks = [
//   {
//     value: 300,
//     label: "Min 300",
//   },

//   {
//     value: 5000,
//     label: "Max 5000",
//   },
// ];

// function valuetext(value: number) {
//   return `${value}`;
// }

export default function TrackFalseSlider({
  valuetext,
  min,
  max,
  step,
  ...rest
}) {
  const marks = [
    {
      value: min,
      label: `Min ${min}`,
    },
    {
      value: max,
      label: `Max ${max}`,
    },
  ];
  return (
    <Box sx={{ width: 250 }}>
      <Slider
        track={"normal"}
        aria-labelledby="track-false-slider"
        // getAriaValueText={valuetext}
        onChange={valuetext}
        //defaultValue={300}
        marks={marks}
        // min={300}
        // max={5000}
        // step={100}
        defaultValue={min}
        min={min}
        max={max}
        step={step}
        sx={{
          "&  .MuiSlider-root": {
            marginTop: "20px!important",
            // right : "27px!important",
          },
          "& .MuiSlider-rail": {
            backgroundColor: "#DB233A!important",
            color:"#DB233A!important",// Set the track color here
            borderRadius:"3px",
          },
          "& .MuiSlider-thumb": {
            backgroundColor: "#DB233A!important",
            width: "14px",
            height: "14px",
          },
          "& .MuiSlider-markLabel": {
            top: "-17px!important",
            color: "#DB233A!important",
            
            // '&[data-index="2"]': {
            //   right: '20%',
            // }
          },
          "& .MuiSlider-markLabel[data-index='0']": {
            left: "-10%!important",
          },
          "& .MuiSlider-markLabel[data-index='2']": {
            right: "10%!important", // Adjust this value to position the max label correctly
          },
          "& .MuiSlider-track":{
            color: "#db233a!important",
            borderRadius: "3px!important",
          }
        }}
        {...rest}
      />
    </Box>
  );
}
